export default "__VITE_ASSET__DHa7DjhX__"